/**
 * 电量数据统一接口
 */
const predict = {
    puzzlePredictedQuantityByHour:"/api/puzzle/puzzlePredictedQuantityByHour",//电量预测
    puzzleLoadFactorAreaCountStatics:"/api/puzzle/puzzleLoadFactorAreaCountStatics",//变压器负载率  
    puzzlePredictQuantityRequiredByHour:"/api/puzzle/puzzlePredictQuantityRequiredByHour",//需量预测  
}

export default predict;